import CustomButton from '../../../common/components/CustomButton';

export default function KaraokeDistrubutionCancelFormView2({
  isDeliveredInJoysound,
  onBackToHome,
} : {
  isDeliveredInJoysound: boolean,
  onBackToHome: () => void,
}) {
  return (
    <form>
      <div className="form__body">
        <dl>
          <dd>
            {isDeliveredInJoysound ? (
              <>
                配信停止の申し込みが完了しました。
                <br />
                <br />
                「配信停止依頼完了」というメールが届いているか必ず確認してください。
                <br />
                (届かない場合はこちらからお問合せください。)
                <br />
              </>
            ) : (
              <>
                キャンセルの受付が完了しました。
                <br />
                数日中にキャンセル処理が完了し、カラオケ配信の管理ページに表示されなくなります。
                <br />
                <br />
                「キャンセル受付完了」というメールが届いているか必ず確認してください。
                <br />
                (届かない場合は
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a href="https://help.frekul.com/140/" target="_blank">こちら</a>
                からお問合せください。)
              </>
            )}
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel" onClick={() => onBackToHome()}>ホームに戻る</CustomButton>
          </li>
        </ul>
      </div>
    </form>
  );
}
